<script>
	// Custom line mark for the Legends of Tasmania experience grid. Drawn to the
	// same geometry as the lucide set used elsewhere (24px box, 1.5 stroke,
	// round caps) so it sits naturally beside them.
	let { class: className = '' } = $props();
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	stroke-width="1.5"
	stroke-linecap="round"
	stroke-linejoin="round"
	class={className}
	aria-hidden="true"
>
	<path d="M7 4.75h8v12.25a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3Z" />
	<path d="M15 8h2a2.5 2.5 0 0 1 0 5h-2" />
	<path d="M7 8.25h8" />
</svg>
